import { createSelector } from "@reduxjs/toolkit";

import { selectSettingsState } from ".";

export const selectAddInSettingsSlice = createSelector(
  [selectSettingsState],
  (settings) => settings.addInSettings
);

export const selectDocumentStyleTemplates = createSelector(
  [selectAddInSettingsSlice],
  (addInSettings) => addInSettings.styleTemplates
);

export const selectHasStyleTemplates = createSelector(
  [selectDocumentStyleTemplates],
  (templates) => templates?.length > 0
);
